/* import __COLOCATED_TEMPLATE__ from './select-kit-create-row.hbs'; */
import SelectKitRowComponent from "select-kit/components/select-kit/select-kit-row";
export default SelectKitRowComponent.extend({
  classNames: "create"
});